/**
 * @file Selfie Capture Face Mask Component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getFaceMaskConfig } from './utilities';
import { getScreenResolution } from '../../../util/screen';

class SelfieCaptureFaceMask extends Component {
  static propTypes = {
    id: PropTypes.string,
  };

  componentDidMount() {
    // FaceMask is fully dependent on the size of the window,
    // which is why we want to resize *real-time*.
    // Animations may leave an ugly whitespace left
    // for a while which is best to avoid for the end-consumer.
    // Note that on mobile devices, this will only happen
    // when the screen is rotated
    window.addEventListener('resize', this.forcedUpdate);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.forcedUpdate);
  }

  forcedUpdate = () => {
    this.forceUpdate();
  };

  render() {
    const {
      id = 'selfie-mask',
      resolution = getScreenResolution(),
      ...props
    } = this.props;
    const { scale, translate, viewBox } = getFaceMaskConfig(resolution);

    return (
      <div className="selfie-mask" key="selfie-mask">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${viewBox.width} ${viewBox.height}`}
          {...props}
        >
          <defs>
            <mask id={id}>
              <rect width="100%" height="100%" fill="#999" />
              <path
                d="M386.719 207.402C386.719 92.934 300.077 0 193.359 0 86.641 0 0 92.934 0 207.402q0 42.609 32.552 120.112Q104.607 500 193.359 500q88.752 0 160.808-172.486 32.552-77.503 32.552-120.112z"
                fill="black"
                transform={`scale(${scale}), translate(${translate.x}, ${translate.y})`}
                x="0"
                y="0"
              />
            </mask>
          </defs>
          <rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            fill="black"
            mask={`url(#${id})`}
          />
        </svg>
      </div>
    );
  }
}

export default SelfieCaptureFaceMask;
